module.exports = __webpack_public_path__ + "static/media/ph-iguana.e0023ab2.jpg";